import { apiClient } from '@/shared/api';
import type { TableViewSnapshot } from '@/entities/settings/models/types';
import type { SystemPreset, SystemPresetCreate, SystemPresetListResponse, SystemPresetUpdate } from './types';

/**
 * Список системных пресетов по GET /system-preset.
 * Без имени таблицы сервер отдаёт пресеты всех таблиц и дашбордов.
 */
export const fetchSystemPresets = async <TSettings = TableViewSnapshot>(
  tableName?: string,
): Promise<SystemPresetListResponse<TSettings>> => {
  const { data } = await apiClient.get<SystemPresetListResponse<TSettings>>('/system-preset', {
    params: { 'table-name': tableName },
  });
  return data;
};

/** Создание системного пресета по POST /system-preset */
export const createSystemPreset = async <TSettings = TableViewSnapshot>(
  preset: SystemPresetCreate<TSettings>,
): Promise<SystemPreset<TSettings>> => {
  const { data } = await apiClient.post<SystemPreset<TSettings>>('/system-preset', preset);
  return data;
};

/** Обновление названия, содержимого или закрепления по PUT /system-preset/{id} */
export const updateSystemPreset = async <TSettings = TableViewSnapshot>({
  id,
  ...changes
}: SystemPresetUpdate<TSettings>): Promise<SystemPreset<TSettings>> => {
  const { data } = await apiClient.put<SystemPreset<TSettings>>(`/system-preset/${id}`, changes);
  return data;
};

/** Удаление системного пресета по DELETE /system-preset/{id} */
export const deleteSystemPreset = async (id: number): Promise<void> => {
  await apiClient.delete(`/system-preset/${id}`);
};
